<template lang="pug">
  #app
    router-view(v-if="!$route.meta.keepAlive")
    keep-alive
      router-view(v-if="$route.meta.keepAlive")
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
  @import './styles/index.scss'; // 全局自定义的css样式
  #app {
    height: 100%;
    font-size: 0.14rem;
  }
  // mint-ui的loading样式依赖于根字体
  .mint-indicator {
    font-size: 0.14rem;
  }
  // 端外上传的input 需要不显示
  .outside-file-input {
    opacity: 0;
    height: 0;
    position: absolute;
  }

</style>
<style lang="scss">
  .mint-toast {
    z-index: 100000 !important;
  }

  .mint-indicator-wrapper {
    z-index: 100000 !important;
  }
</style>
